export default "__VITE_ASSET__BDhv7Y5o__"